const menuButton = document.querySelector('[data-menu-toggle]');
const nav = document.querySelector('[data-primary-nav]');

if (menuButton && nav) {
  menuButton.addEventListener('click', () => {
    const isOpen = nav.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', String(isOpen));
  });
}

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const featuredImage = gallery.querySelector('[data-product-featured-image]');
  const thumbnails = gallery.querySelectorAll('[data-product-thumbnail]');
  const variantSelect = gallery.querySelector('[data-product-variant-select]');
  const currentPrice = gallery.querySelector('[data-product-current-price]');
  const comparePrice = gallery.querySelector('[data-product-compare-price]');
  const submitButton = gallery.querySelector('[data-product-submit]');

  const setFeaturedImage = ({ imageSrc, imageSrcset, imageAlt, mediaId }) => {
    if (!featuredImage || !imageSrc) return;

    featuredImage.src = imageSrc;
    if (imageSrcset) featuredImage.srcset = imageSrcset;
    featuredImage.alt = imageAlt || '';

    thumbnails.forEach((item) => {
      const isActive = Boolean(mediaId) && item.dataset.mediaId === String(mediaId);
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', String(isActive));
    });
  };

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      setFeaturedImage({
        imageSrc: thumbnail.dataset.imageSrc,
        imageSrcset: thumbnail.dataset.imageSrcset,
        imageAlt: thumbnail.dataset.imageAlt,
        mediaId: thumbnail.dataset.mediaId,
      });
    });
  });

  variantSelect?.addEventListener('change', () => {
    const selectedOption = variantSelect.selectedOptions[0];
    if (!selectedOption) return;

    if (currentPrice) currentPrice.textContent = selectedOption.dataset.price || '';

    if (comparePrice) {
      const comparePriceValue = selectedOption.dataset.comparePrice || '';
      comparePrice.textContent = comparePriceValue;
      comparePrice.hidden = !comparePriceValue;
    }

    if (submitButton) {
      const isAvailable = selectedOption.dataset.available === 'true';
      submitButton.disabled = !isAvailable;
      submitButton.textContent = isAvailable
        ? submitButton.dataset.addLabel
        : submitButton.dataset.soldOutLabel;
    }

    setFeaturedImage({
      imageSrc: selectedOption.dataset.imageSrc,
      imageSrcset: selectedOption.dataset.imageSrcset,
      imageAlt: selectedOption.dataset.imageAlt,
      mediaId: selectedOption.dataset.mediaId,
    });

    if (selectedOption.dataset.variantUrl) {
      window.history.replaceState({}, '', selectedOption.dataset.variantUrl);
    }
  });
});

document.querySelectorAll('[data-size-guide-dialog]').forEach((dialog) => {
  const closeButton = dialog.querySelector('[data-size-guide-close]');

  closeButton?.addEventListener('click', () => dialog.close());

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
});

document.querySelectorAll('[data-size-guide-open]').forEach((button) => {
  button.addEventListener('click', () => {
    const dialog = document.getElementById(button.dataset.sizeGuideOpen);
    if (!dialog) return;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  });
});
